import { PROPOSTA_SITUACOES } from '@/types/PropostaSituacoes'
import { PropostaHelper } from '@/utils/PropostaHelper'
import { Vue } from 'vue-property-decorator'
import { VChip } from 'vuetify/lib'

export const ChipSituacaoIsolve = Vue.extend({
	extends: VChip,
	name: 'ChipSituacaoIsolve',
	props: {
		status: { default: 0 }
	},
	computed: {
		getColors(): any {
			switch (this.status) {
				case PROPOSTA_SITUACOES.ANDAMENTO:
					return { color: '#F0D0F0', textColor: '#5C0F45' }
				case PROPOSTA_SITUACOES.APROVADO:
					return { color: '#0B5C11', textColor: '#FFFF' }
				case PROPOSTA_SITUACOES.CANCELADO:
					return { color: '#AC1E1E', textColor: '#FFFF' }
				case PROPOSTA_SITUACOES.PENDENTE:
				case PROPOSTA_SITUACOES.DIVERGENCIA_CADASTRO:
				case PROPOSTA_SITUACOES.APROVADO_CONDICIONADO:
					return { color: '#FFE381', textColor: '#503E01' }
				case PROPOSTA_SITUACOES.EM_ANALISE:
					return { color: '#7B2661', textColor: '#FFFF' }
				case PROPOSTA_SITUACOES.ANALISE_ATTA:
					return { color: '#ECE2F8', textColor: '#3E028A' }
				case PROPOSTA_SITUACOES.ANALISE_BANCO:
					return { color: '#A9CDFF', textColor: '#17273C' }
				case PROPOSTA_SITUACOES.ANALISE_BANCO_DUVIDA:
					return { color: '#142944', textColor: '#A9CDFF' }
				case PROPOSTA_SITUACOES.FINALIZADO:
					return { color: '#D9C0F7', textColor: '#2E0068' }
				case PROPOSTA_SITUACOES.NAO_PASSIVEL_DEFESA:
				case PROPOSTA_SITUACOES.REVISAO:
				case PROPOSTA_SITUACOES.REPROVADO:
				case PROPOSTA_SITUACOES.NAO_PROCESSADO_BANCO:
					return { color: '#FBE3E3', textColor: '#AC1E1E' }
				case PROPOSTA_SITUACOES.NOTAS_DE_EXIGENCIA:
					return { color: '#FBE3E3', textColor: '#AC1E1E' }
				case PROPOSTA_SITUACOES.CARTORIO_EXTERNO:
					return { color: '#E4E4E8', textColor: '#9595A4' }
			}
		},
		getName(): string {
			return PropostaHelper.getSituacaoDescricao(this.status)
		}
	},
	render() {
		if (this.status > 0)
			return (
				<VChip small class="px-5" color={this.getColors.color}>
					<span class="font-weight-bold" style={{ color: this.getColors.textColor }}>
						{this.getName}
					</span>
				</VChip>
			)

		return <div>-</div>
	}
})

export default ChipSituacaoIsolve
